// Application constants
export const FRONTEND_APP_VERSION = '1.1.5';

// Debug settings
export const DEBUG = false;
